<div [ngClass]="{ hidden: visible }">
	<div
		class="error"
		*ngIf="dataError"
		[innerHTML]="'PROMPTUARY.ERRORS.CONNECTION_ERROR' | translate"
	></div>

	<div class="loading" *ngIf="!memed.loaded && !dataError">
		<p>{{ 'PROMPTUARY.MEMED_CONNECTING' | translate }}</p>
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>

	<div
		class="memed-container"
		[ngClass]="{ hidden: !memed.loaded }"
		id="memedContainer"
	></div>

	<div class="modal__wrapper">
		<create-memed-dialog
			[isOpen]="showCreateMemedUserModal"
			(close)="onCloseCreateMemedUserModal()"
			(create)="onCreateMemedUser()"
		></create-memed-dialog>
	</div>
</div>
